module.exports = __webpack_public_path__ + "img/jiaot7.5c48eefa.png";